import React from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import MultiStepForm from "./MultiStepForm";
import VbsRegistrationFlow from "./VbsRegistrationFlow";
import SponsorshipApplication from "./SponsorshipApplication";
import Admin from "./Admin";
import SurveyPage from "./SurveyPage";
import { isSurveyLive } from "./dateRouting";

function LandingPageRedirect() {
  return <Navigate to={isSurveyLive() ? "/survey" : "/register"} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPageRedirect />} />
        <Route path="/register" element={<MultiStepForm />} />
        <Route path="/vbs" element={<VbsRegistrationFlow />} />
        <Route path="/sponsorship" element={<SponsorshipApplication />} />
        <Route path="/survey" element={<SurveyPage />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
